import React, { useEffect, useState } from 'react';
import { useAccount, useMsal } from "@azure/msal-react";
import { agent } from '@shared/services/agent';
import { microsoftRequest } from '@shared/services/EnvironmentVariables';
import { AuthType, persistAuthType } from "@shared/utils/AuthUtils";
import AuthWrapper from "./components/AuthWrapper";
import { AzureErrorHandlingMessages, MsalErrorCodes } from '@shared/ui/organisms/auth/AzureErrorHandlingMessages';
import { setRegisterAuthType } from "@shared/store/auth.duck";
import { DialogIdentifiers, openDialog } from "@shared/store/dialog.duck";
import { useDispatch } from "react-redux";
import { emitRegisterEvent } from '@features/auth/services/RegisterService';
import { registerWithMicrosoft } from '@shared/auth/authMachine.duck';
import { failureNotification } from '@shared/store/notification.duck';


export default function RegisterWithAzure() {
  const [error, setError] = useState('');
  const {accounts, instance, inProgress} = useMsal();
  const account = useAccount(accounts[0] || {});
  const dispatch = useDispatch();

  useEffect(() => {
    if (account) {
      instance.setActiveAccount(account);

      (async () => {
        try {
          await (dispatch(registerWithMicrosoft({ source: 'web' })) as any).unwrap();
          persistAuthType(AuthType.Microsoft, dispatch);
          emitRegisterEvent();
          await registerWithServer();
          window.location.href = '/whereabouts/team';
        } catch (err: any) {
          console.error(err);
          instance.acquireTokenRedirect({ ...microsoftRequest.register });
        }
      })();
    }
  }, [instance, account, inProgress])

  const registerWithServer = async () => {
    const informMe = localStorage.getItem('informMe') === 'true';

    try {
      let requestBody = {informMe: informMe};
      const ad = localStorage.getItem('ad')
      if (ad) {
        // @ts-ignore
        requestBody['ad'] = ad;
      }

      await agent.requests.post('/register/azure', requestBody);
    } catch (e: any) {
      console.error(e);
      const message = (e?.message ?? '').toString().trim();
      dispatch(failureNotification(message || 'Failed to register'));
      setError(message || 'Failed to register');
      return;
    }
    try {
      window.location.href = "/whereabouts/team"
    } catch (e: any) {
      console.error(e)
      setError(e)
    }
  }

  const registerWithMs = () => {
    dispatch(setRegisterAuthType(AuthType.Microsoft));
    dispatch(openDialog(DialogIdentifiers.SignUpTermsDialog));
  }

  return (
    <AuthWrapper dataTest="register-with-azure" title="" spinner={!error} hideLoginLink={!!error}>
      {error && <AzureErrorHandlingMessages goBackLink="/register"
                                            onRetryClicked={registerWithMs}
                                            title="Register failed"
                                            errorCode={error as MsalErrorCodes}/>}
    </AuthWrapper>
  )
}
